import { Box } from '@chakra-ui/react';
import { Pressable, Text, VStack } from 'components/ui';
import React from 'react';
import { useDiagnosis } from '../../api/onboarding/useDiagnosis';
import { Loader } from '../Loader';
import { Pill } from './Pill';
import { DiagnosisCategory } from '../../api/types';
import { useFormData } from 'utils/formReducer';

type Props = {
  selectDiagnoses: (ids: string[]) => void;
};

export const GIConditionsList = ({ selectDiagnoses }: Props) => {
  const { state: formData } = useFormData();
  const { data: diagnosisItems, isLoading } = useDiagnosis({
    core: false,
    category: [DiagnosisCategory.UpperGI, DiagnosisCategory.Other],
  });

  const onSelectDiagnosis = (dx_id: string) => {
    const selectedIds = formData.diagnosis_ids?.includes(dx_id)
      ? [...formData.diagnosis_ids.filter((id: string) => id !== dx_id)]
      : [...formData.diagnosis_ids, dx_id];

    selectDiagnoses(selectedIds);
  };

  if (isLoading) {
    return (
      <Box
        backgroundColor="muted.100"
        p={0}
        data-testid="onboarding-gi-conditions-loading-spinner"
      >
        <Loader loading={true} />
      </Box>
    );
  }

  if (!diagnosisItems?.length) return null;

  return (
    <VStack
      gap="10px"
      w="100%"
      align="stretch"
      data-testid="onboarding-gi-conditions"
    >
      <Text textStyle="label.section" textAlign="left">
        We can also help with these diagnoses:
      </Text>

      <Box
        display="flex"
        flexDirection="row"
        flexWrap="wrap"
        gap="9px"
        data-testid={'onboarding-gi-conditions-list'}
      >
        {diagnosisItems
          ?.filter(
            (item) =>
              ![DiagnosisCategory.IBD, DiagnosisCategory.IBS].includes(
                item.category
              )
          )
          ?.map(({ diagnosis, id }) => {
            const isSelected = formData.diagnosis_ids?.includes(id);

            return (
              <Pressable
                key={id}
                onClick={() => onSelectDiagnosis(id)}
                data-testid={'onboarding-gi-conditions-list-item'}
              >
                <Pill isSelected={isSelected} text={diagnosis} />
              </Pressable>
            );
          })}
      </Box>
    </VStack>
  );
};
